export const EXPORT_SELECT_OPTION = 'REPORTING_EXPORT_SELECT_OPTION';

export const selectOption = ({ selectedValue, selectName }) => ({
  type: EXPORT_SELECT_OPTION,
  selectedValue,
  selectName,
});
